import { SharingPMOResponse } from '@/app/models/sharingPMO';
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
  fontWeight: 'bold',
}));

const RowTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
}));

type SharingPMOTableGridParams = {
  rows: SharingPMOResponse[];
  count: number;
  rowsPerPage: number;
  setRowsPerPage: (n: number) => void;
  page: number;
  setPage: (n: number) => void;
};

export default function SharingPMOTable(props: SharingPMOTableGridParams) {
  const { t } = useTranslation(['pmo', 'common']);
  const { rows, count, rowsPerPage, setRowsPerPage, page, setPage } = props;

  return (
    <div>
      <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
        <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead>
            <TableRow>
              <HeaderTableCell>{t('common:collaborator')}</HeaderTableCell>
              <HeaderTableCell>{t('common:resource.badge')}</HeaderTableCell>
              <HeaderTableCell>{t('origin.project.code')}</HeaderTableCell>
              <HeaderTableCell>{t('origin.project.name')}</HeaderTableCell>
              <HeaderTableCell>{t('destini.project.name')}</HeaderTableCell>
              <HeaderTableCell>{t('sharing.value')}</HeaderTableCell>
              <HeaderTableCell>{t('sharing.type')}</HeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index = 0) => (
              <TableRow key={row.resourceBadge + index}>
                <RowTableCell>{row.resourceName}</RowTableCell>
                <RowTableCell>{row.resourceBadge}</RowTableCell>
                <RowTableCell>{row.originProjectCode}</RowTableCell>
                <RowTableCell>{row.originProjectName}</RowTableCell>
                <RowTableCell>{row.destiniProjectName}</RowTableCell>
                <RowTableCell>{row.sharingValue}</RowTableCell>
                <RowTableCell>{row.sharingType}</RowTableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell sx={{ textAlign: 'center' }} colSpan={7}>
                  <Typography variant="subtitle2">
                    {t('common:no.data.for.the.chosen.period.and.search.term')}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          sx={{ width: '100%' }}
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={count || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, p) => setPage(p)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          labelDisplayedRows={({ from, to, count: tcount }) => `${from}-${to} ${t('de')} ${tcount}`}
          labelRowsPerPage={t('common:items.per.page')}
        />
      </TableContainer>
    </div>
  );
}
